import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, LogIn } from "lucide-react";
import { login, getToken } from "@/lib/admin-api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@eclipsecubiertas.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (getToken()) {
    // already logged
    setTimeout(() => nav("/admin", { replace: true }), 0);
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Email y contraseña requeridos");
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Bienvenido");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/images/logo_eclipse_oficial.png" alt="Eclipse" className="h-14 w-auto mx-auto mb-3" />
          <p className="text-white/60 text-sm tracking-wider">PANEL ADMIN · FLEXSHADE</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl p-7 md:p-8 shadow-2xl" data-testid="admin-login-form">
          <h1 className="text-2xl font-black mb-1 section-title">Iniciar sesión</h1>
          <p className="text-sm text-neutral-500 mb-6">Accede a tu panel de administración</p>

          <label className="form-label flex items-center gap-1.5"><Mail className="w-3.5 h-3.5"/> Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input mb-4"
            data-testid="admin-email"
            placeholder="admin@eclipsecubiertas.com"
            autoComplete="username"
          />

          <label className="form-label flex items-center gap-1.5"><Lock className="w-3.5 h-3.5"/> Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-input mb-6"
            data-testid="admin-password"
            placeholder="••••••••"
            autoComplete="current-password"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-submit"
            className="btn-primary w-full py-3 rounded-xl inline-flex items-center justify-center gap-2 disabled:opacity-60"
          >
            <LogIn className="w-5 h-5" />
            {loading ? "Ingresando..." : "Ingresar"}
          </button>

          <Link to="/" className="block text-center text-xs text-neutral-500 mt-5 hover:text-neutral-900">
            ← Volver al sitio
          </Link>
        </form>
      </div>
    </div>
  );
}
